import React from 'react';
import ReactDOM from 'react-dom/client';
import { CSSProperties } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import the necessary components
import './index.css';
import reportWebVitals from './reportWebVitals';
import BuilderView from './builder.microlet2';
import UpdateMicrolet from './update.microlet';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Styles for the layout
const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  height: '100vh', // Full viewport height
  width: '100vw', // Full viewport width
};

const leftPanelStyle: CSSProperties = {
  flex: 1, // Take up 50% of the width
  borderRight: '1px solid #ccc', // Add a border between panels
  padding: '16px',
  overflow: 'auto', // Scrollable if content exceeds height
};

const rightPanelStyle: CSSProperties = {
  flex: 1, // Take up 50% of the width
  padding: '16px',
  overflow: 'auto', // Scrollable if content exceeds height
};

const App: React.FC = () => {
  return (
    <div style={containerStyle}>
    {/* Left side: BuilderView */}
    {/* <div style={leftPanelStyle}>
      <BuilderView />
    </div> */}

    {/* Right side: UpdateMicrolet */}
    <div style={rightPanelStyle}>
      <UpdateMicrolet />
    </div>
  </div>
  );
};

root.render(
  <React.StrictMode>
    {/* <Router>
      <Routes>
        <Route path="/view" element={<BuilderView />} />
        <Route path="/update" element={<UpdateMicrolet />} />
      </Routes>
    </Router> */}
    <App></App>
  </React.StrictMode>

  // split the window in two. leftside show BuilderView and right side show UpdateMicrolet apply proper CSS

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
